// local-storage keys
export const localStorageKeys = {
    aparajithaData: "aparajithaData",
    licenseExportJob: "licenseExportJob",
  };
